/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Subscription } from './Subscription';
import {
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
} from './Subscription';

import {
     MyDbCustomerSubscriptionFromJSONTyped
} from './';

/**
 * tenant-specific user subscriptions
 * @export
 * @interface TenantCustomerSubscription
 */
export interface TenantCustomerSubscription {
    /**
     * 
     * @type {string}
     * @memberof TenantCustomerSubscription
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantCustomerSubscription
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantCustomerSubscription
     */
    subscriptionName?: string;
    /**
     * 
     * @type {Subscription}
     * @memberof TenantCustomerSubscription
     */
    subscription?: Subscription;
    /**
     * 
     * @type {number}
     * @memberof TenantCustomerSubscription
     */
    termsConditionsNumber?: number;
}

/**
 * Check if a given object implements the TenantCustomerSubscription interface.
 */
export function instanceOfTenantCustomerSubscription(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantCustomerSubscriptionFromJSON(json: any): TenantCustomerSubscription {
    return TenantCustomerSubscriptionFromJSONTyped(json, false);
}

export function TenantCustomerSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantCustomerSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['tenant'] === 'MY_DB') {
            return MyDbCustomerSubscriptionFromJSONTyped(json, true);
        }
    }
    return {
        
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'subscriptionName': !exists(json, 'subscriptionName') ? undefined : json['subscriptionName'],
        'subscription': !exists(json, 'subscription') ? undefined : SubscriptionFromJSON(json['subscription']),
        'termsConditionsNumber': !exists(json, 'termsConditionsNumber') ? undefined : json['termsConditionsNumber'],
    };
}

export function TenantCustomerSubscriptionToJSON(value?: TenantCustomerSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customerId': value.customerId,
        'tenant': value.tenant,
        'subscriptionName': value.subscriptionName,
        'subscription': SubscriptionToJSON(value.subscription),
        'termsConditionsNumber': value.termsConditionsNumber,
    };
}

